<form id="spec-line-edit-form" [formGroup]="specificationLineForm">
  <div class="flex flex-row place-items-center justify-between">
    <div class="section-header justify-self-start">
      <p class="p-0 mt-3" id="specification-line-name">{{ lineName }}</p>
      <p class="specification-type-label mb-1">{{ translationService.translate('specificationTypeText') }}</p>
      <mat-button-toggle-group
        id="spec-type-toggle-button"
        name="fontStyle"
        class="mic-button-toggle-group mt-0 mb-2"
        aria-label="CAMSpecType"
      >
        <mat-button-toggle
          id="spec-type-toggle-button-rr"
          value="10"
          class="mic-button-toggle mic-button-toggle-disabled"
          [disabled]="isDefault"
          [checked]="specline.type === 10"
          >{{ translationService.translate('repairAndRetreadText') }}</mat-button-toggle
        >
        <mat-button-toggle
          id="spec-type-toggle-button-ro"
          value="20"
          class="mic-button-toggle mic-button-toggle-disabled"
          [disabled]="isDefault"
          [checked]="specline.type === 20"
          >{{ translationService.translate('repairOnlyText') }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
  </div>

  <app-spec-line-definition
    id="spec-line-definition-component"
    [specLine]="specline"
    [editMode]="isDefault ? false : editMode"
  ></app-spec-line-definition>

  <app-ntr-age id="ntr-and-age-component" [ntr]="specline.ntr" [age]="specline.age" [editMode]="editMode"></app-ntr-age>

  @for (limit of specline.limits; track limit; let i = $index) {
  <div>
    <app-repair-limit id="repair-limit-{{ i }}" [limit]="limit" [index]="i" [specLine]="specline" [editMode]="editMode" />
  </div>
  } @if (editMode && !secondRepairLimitExists) {
  <span class="add-repair-limit" id="add-repair-limit-link" (click)="addRepairLimit()">{{
    translationService.translate('addRepairLimitText')
  }}</span>
  }
</form>
